import * as React from "react";
import { Helmet } from "react-helmet";
import { useSelector } from "react-redux";
import { hasClaim } from "../../../lib/claims/utils";
import { UnAuthorizedView } from "@/components/unauthorized-view/UnAuthorizedView";
import { profileSelectors } from "@/redux/profile/selectors";
import { SurchargeDocumentsView } from "./SurchargeDocumentsView";
import { UPDATE_ROUTE_PRICES } from "@/types/claims/constants";

interface Props {}

export const SurchargeDocumentsScreen: React.FC<Props> = () => {
  const { claims } = useSelector(profileSelectors.getGlobal);

  return (
    <>
      <Helmet title="Surcharge documents" />
      {hasClaim(claims, [UPDATE_ROUTE_PRICES]) ? (
        <SurchargeDocumentsView />
      ) : (
        <UnAuthorizedView />
      )}
    </>
  );
};
